import { Card, CardBody, Spinner } from 'reactstrap';
import DonutChart from './DonutChart';
import React from 'react';
import classnames from 'classnames';

type Props = {
  title: string;
  legend?: string;
  data?: {
    positiveItem: { name: string; value: number };
    negativeItem: { name: string; value: number };
  };
};
const DashCard = ({ title, legend, data }: Props) => {
  if (!data)
    return (
      <Card className="border-0 shadow mb-3">
        <CardBody>
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: '128px' }}
          >
            <Spinner />
          </div>
        </CardBody>
      </Card>
    );

  const { positiveItem, negativeItem } = data;
  return (
    <Card className="border-0 shadow mb-3 h-100 w-100">
      <CardBody className="d-flex align-items-center justify-content-center p-3 p-md-4">
        <div className="d-flex flex-column flex-sm-row align-items-center align-items-sm-start w-100">
          <div className="mb-2 mb-sm-0 me-sm-3 d-flex justify-content-center flex-shrink-0">
            <DonutChart
              width={120}
              height={100}
              innerRadius={35}
              margin={4}
              data={[negativeItem, positiveItem]}
            />
          </div>
          <div className="text-center text-sm-start flex-grow-1 min-width-0">
            <h6 className="fw-bolder text-dark mb-1">{title}</h6>
            <p
              className={classnames('text-gray-800 small mb-2', {
                'mb-3': !legend
              })}
            >
              {legend}
            </p>
            <div className="d-flex flex-column align-items-center align-items-sm-start">
              <div className="d-flex align-items-center mb-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="8"
                  height="8"
                  viewBox="0 0 8 8"
                  fill="none"
                  className="flex-shrink-0"
                >
                  <circle cx="4" cy="4" r="4" fill="#0076D5" />
                </svg>
                <span className="ms-2 small text-secondary text-truncate">
                  {positiveItem.name}
                </span>
                <span className="ms-1 fw-bold small flex-shrink-0">
                  {positiveItem.value}
                </span>
              </div>
              <div className="d-flex align-items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="8"
                  height="8"
                  viewBox="0 0 8 8"
                  fill="none"
                  className="flex-shrink-0"
                >
                  <circle cx="4" cy="4" r="4" fill="#F87269" />
                </svg>
                <span className="ms-2 small text-secondary text-truncate">
                  {negativeItem.name}
                </span>
                <span className="ms-1 fw-bold small flex-shrink-0">
                  {negativeItem.value}
                </span>
              </div>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default DashCard;
